/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="formhelperservice.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="validationerrormessageresolverservice.ts" />
/// <reference path="usermessagesservice.ts" />

module App.Common.Services {
	'use strict';

	export class ModelStateValidationService {

		public static $inject = [
			'app.common.services.userMessagesService',
			'app.common.services.formHelperService'
		];

		constructor(
			private userMessages: Services.UserMessagesService,
			private formHelper: Services.FormHelperService) {}

		public modelStateMessages: {[key: string]: string} = {};

		public clearModelStateMessages() {
			this.modelStateMessages = {};
		}

		public getErrorMessageForElement(el: angular.IAugmentedJQuery): string {
			const inputName = el.attr('name');
			if (!inputName) {
				throw (
					'An input with error type "modelstate" must have a "name" attribute which matches the error property name on the model state.');
			}
			if (!this.modelStateMessages[inputName]) {
				throw (`No error message registered for input "${inputName}"`);
			}
			return this.modelStateMessages[inputName];
		}

		public handleModelState(modelState: {[s: string]: string[];}): boolean {

			const scope = this.formHelper.mainFormScope();
			const form = this.formHelper.mainForm();

			if (!form) {
				return false;
			}

			this.clearModelStateMessages();

			_(modelState)
				.keys()
				.forEach(key => {

					const inputName = key.replace(/^model\./, '');
					const message = modelState[key].join('\r\n');

					/* If an input is found on the form with the same value in it's name attribute
					 as the field name on the modelState, add set that input to have a validity error
					of type "modelstate", and add the actual message to a dictionary in the
					error message resolver so that it can be rendered next to the actual field. */
					if (form[inputName]) {
						this.modelStateMessages[inputName] = message;
						form[inputName].$setValidity('modelstate', false);
						const input = this.formHelper.inputElement(inputName);
						var unwatch = scope.$watch(input.attr('ng-model'),
						(newValue: any, oldValue: any) => {
							if (newValue !== oldValue) {
								form[inputName].$setValidity('modelstate', true);
								unwatch();
							}
						});
					}
					//If no matching input field is found, add the message to the to the user messages instead
					else {
						this.userMessages.addMessage(message, UserMessageType.Error);
					}
				});

			return true;

		}

	}

	angular
		.module('app.common.services')
		.service('app.common.services.modelStateValidationService', ModelStateValidationService);
}